import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const CupBottoms = () => <ProductDetailPage {...getProductPageConfig('cupBottoms')} />;

export default CupBottoms;
